import config from "config/config"

export default class StorageService {
    static setItem(key: string, value: any) {
        try {
            localStorage.setItem(this.prefixKey(key), typeof value === "string" ? value : JSON.stringify(value))
        } catch(e) {
            console.log(e)
        }
    }

    static getItem(key: string) {
        try {
            return localStorage.getItem(this.prefixKey(key))
        } catch(e) {
            console.log(e)
        }
    }

    static removeItem(key: string) {
        try {
            localStorage.removeItem(this.prefixKey(key))
        } catch(e) {
            console.log(e)
        }
    }

    private static prefixKey(key: string) {
        return `${config.prefix}.${key}`
    }
}
